import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);
// ScrollTrigger.defaults({ scroller: '#smooth-content' });

// ========================================
// INTRO ANIMATIONS
// ========================================

function createIntroAnimations() {
	const tlIntro = gsap.timeline({ ease: 'power4.inOut' });

	addHeroAnimation(tlIntro);
	addHeroContentAnimations(tlIntro);
	addHeaderAnimations(tlIntro);

	return tlIntro;
}

function addHeroAnimation(timeline) {
	timeline.fromTo(
		'.hero',
		{
			opacity: 0,
			ease: 'power4.inOut',
			delay: 0.5,
			duration: 1,
		},
		{
			opacity: 1,
			// duration: 1,
		},
	);
}

function addHeroContentAnimations(timeline) {
	timeline.from('.hero__content h1', {
		y: -20,
		opacity: 0,
		ease: 'power4.inOut',
		duration: 1,
	});

	timeline.from(
		'.hero__content p',
		{
			y: 20,
			opacity: 0,
			ease: 'power4.inOut',
			duration: 0.6,
		},
		'-=0.3',
	);

	// Infinite bounce animation with 1s pause between repeats

	const arrowTl = gsap.timeline({
		repeat: -1,
		// yoyo: true,
		repeatDelay: 1,

		// scrollTrigger: {
		// 	trigger: widget,
		// 	start: 'top 50%',
		// },
	});

	// arrowTl.to(
	// 	'svg.arrow',
	// 	{
	// 		scaleY: 1,
	// 		y: -15,
	// 		transformOrigin: '50% 100%',
	// 		duration: 0.3,
	// 		ease: 'elastic.out(1, 0.4)',
	// 	},
	// 	'flatten+=0.1'
	// );

	// arrowTl.to(
	// 	'svg.arrow',
	// 	{
	// 		scaleY: 0.7,
	// 		transformOrigin: '50% 100%',
	// 		duration: 0.15,
	// 		ease: 'power1.in',
	// 	},
	// 	'flatten'
	// );

	arrowTl.to('svg.arrow', {
		y: -15,
		// scaleX: 1.2,
		duration: 0.8,
		ease: 'power2.out',
	});
	arrowTl.fromTo(
		'svg.arrow',
		{
			y: -15,
			// scaleX: 1.2,
		},
		{
			y: 0,
			// scaleX: 1,
			duration: 1,
			ease: 'bounce.out',
		},
	);
}

function addHeaderAnimations(timeline) {
	// timeline.to('header .brand', {
	// 	autoAlpha: 1,
	// });

	timeline.to(
		'header nav',
		{
			autoAlpha: 1,
		},
		'<',
	);

	// Header animation
	timeline.from('header .brand', {
		y: -10,
		opacity: 0,
		duration: 0.5,
		ease: 'power4.inOut',
	});

	// Navigation items stagger animation
	timeline.from(
		'nav ul li',
		{
			y: 10,
			opacity: 0,
			duration: 0.8,
			stagger: 0.2,
			ease: 'power4.inOut',
		},
		'-=0.3',
	);
}

function getScrollElements() {
	return {
		// stickySection: document.querySelector('.sticky-section'),
		// stickySections: document
		// 	.querySelector('.sticky-section')
		// 	.querySelectorAll('section'),
		property: document.getElementById('property'),
		property_content: document.getElementById('property-content'),
		vines_perspective: document.querySelector('.methodology-background'),
		vines_silhouette: document.getElementById('vines-silhouette'),
		vines_posts: document.getElementById('vines-posts'),
		methodology: document.getElementById('methodology'),
		wines: document.getElementById('wines'),
	};
}
// ========================================
// SCROLL ANIMATIONS SETUP
// ========================================

function setupScrollAnimations() {
	const elements = getScrollElements();
	// setupStickySection(elements);
	createHeroTransitions(elements);
	// createStickySection(elements);
	// createPropertyAnimations(elements);
	// createMethodologyAnimations(elements);
	fullScreenBackgroundTransition();
	propertyAnimations();
	methodologyAnimations();
	createWinesAnimations(elements);
	createImageAnimations(elements);
	createFooterAnimations(elements);
}

function createHeroTransitions(elements) {
	// console.log(elements);

	let timeline = gsap.timeline({
		scrollTrigger: {
			trigger: '#hero',
			start: '1% top',
			// pin: true,
			// pinSpacing: false,
			// end: () => `+=${totalStickyHeight}`,
			// snap: {
			// 	// snapTo: 0.25,
			// 	snapTo: 'labels',
			// 	duration: 0.05,
			// 	// ease: 'power1.out',
			// 	delay: 0,
			// },
			// ease: 'power4.inOut',
			// scrub: 3,
			toggleActions: 'play none none reverse',

			// markers: true,
		},
	});
	// timeline.set('.hero', { zIndex: 0 });
	timeline.addLabel('hero').fromTo(
		'.hero',
		{
			opacity: 1,
			scale: 1,
		},
		{
			opacity: 0.1,
			scale: 1.05,
			ease: 'power10.inOut',
			duration: 1,
		},
	);

	timeline.fromTo(
		'.hero__content h1',
		{
			letterSpacing: 0,
		},
		{
			letterSpacing: 3,
		},
		'<',
	);

	timeline.to(
		'.hero__content',
		{
			opacity: 0,
			scale: 1.2,
			ease: 'power10.inOut',
			duration: 0.8,
		},
		'<',
	);

	timeline.to(
		'#certification-logos',
		{
			opacity: 0,
		},
		'<',
	);
}

function fullScreenBackgroundTransition() {
	let fullScreenBackground = document.querySelector('.fullscreen-image');
	let timeline = gsap.timeline({
		scrollTrigger: {
			trigger: fullScreenBackground,
			start: 'top top',
			endTrigger: '#methodology',
			end: 'bottom top',
			scrub: 1,
			pin: true,
			pinSpacing: false,
			// markers: true,
		},
	});

	timeline.fromTo(
		fullScreenBackground,
		{
			clipPath: 'polygon(15% 20%, 40% 20%, 40% 90%, 15% 90%)',
		},
		{
			clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
			ease: 'power20.inOut',
			scale: 1.2,
		},
	);
}

function propertyAnimations() {
	const tl = gsap.timeline({
		ease: 'expo.inOut',
		scrollTrigger: {
			trigger: '#property',
			start: '50% 20%',
			toggleActions: 'play none none reverse',
			// markers: true,
		},
	});
	tl.to('#property-content', {
		autoAlpha: 0,
	});
}

function methodologyAnimations() {
	const tlMethod = gsap.timeline({
		ease: 'expo.inOut',
		scrollTrigger: {
			trigger: '#methodology',
			start: 'bottom 50%',
			toggleActions: 'play none none reverse',
			// markers: true,
			// scrub: true,
			id: 'method',
		},
	});

	tlMethod.to('.fullscreen-image', {
		autoAlpha: 0,
		duration: 1,
	});
	// tlMethod.from('#inspection-raisins', {
	// 	autoAlpha: 0,
	// 	xPercent: -10,
	// });
}

function createWinesAnimations(elements) {
	let winesTl = gsap.timeline({
		duration: 1,
		ease: 'elastic.inOut',
		scrollTrigger: {
			trigger: elements.wines,
			start: 'top 60%',
			toggleActions: 'play none none reverse',
			// scrub: 3,
			// id: 'property',
			// markers: true,
		},
	});

	winesTl.from(elements.wines.querySelectorAll('.wines-list__item'), {
		autoAlpha: 0,
		yPercent: 10,
		stagger: 0.3,
		ease: 'back.out(4)', // increased overshoot
		duration: 0.5,
	});
}

// ========================================
// STANDALONE ANIMATIONS
// ========================================

function createImageAnimations() {
	const tlImages = gsap.timeline({
		scrollTrigger: {
			trigger: '.widget-images',
			start: 'top 70%',
			toggleActions: 'play none none reverse',
		},
	});

	tlImages.from('.widget-images__item', {
		yPercent: -20,
		autoAlpha: 0,
		stagger: 0.3,
		duration: 1.5,
		ease: 'expo.out',
	});

	return tlImages;
}

function createFooterAnimations() {
	gsap.from('footer', {
		scrollTrigger: {
			trigger: 'footer',
			start: 'top bottom',
			toggleActions: 'play none none reverse',
		},
		y: 50,
		opacity: 0,
		duration: 1,
		ease: 'power2.out',
	});
}

// ========================================
// INITIALIZATION
// ========================================

function initializeAnimations() {
	// Initialize intro animations
	createIntroAnimations();

	// Initialize scroll-based animations
	setupScrollAnimations();
}

export { initializeAnimations };
// Initialize all animations
// initializeAnimations();
